// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"61817eab","453":"37eec249"}[chunkId] + ".chunk.js";
};